import ReactQuill from 'react-quill';

const Inline = ReactQuill.Quill.import('blots/inline');

class BigMyeongjoFont extends Inline {
  static create() {
    const node = super.create();
    node.setAttribute('class', 'bigMyeongjoFont');
    return node;
  }
  static formats(node) {
    return {
      class: node.getAttribute('class'),
    };
  }
}
BigMyeongjoFont.blotName = 'bigmyeongjo';

export default BigMyeongjoFont;
